import { render, staticRenderFns } from "./modalEditarTurno.vue?vue&type=template&id=45ac416a&"
import script from "./modalEditarTurno.vue?vue&type=script&lang=js&"
export * from "./modalEditarTurno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports